<template>
  <div>
    <div class="card shadow">
      <div class="card-header bg-transparent">
        <div>
          <h3 class="mb-0">
            {{ $tc('message.patients', 1) }}
          </h3>
        </div>
      </div>

      <div class="card-body">
        <div class="card-title" v-if="can">
          <b-dropdown size="sm" split :text="$t('message.add')" class="mb-2" variant="primary">
            <b-dropdown-item-button @click="toAddInstitution"> {{ $tc('message.institutions', 1) }}</b-dropdown-item-button>
            <b-dropdown-item-button @click="toAddSubscriber"> {{ $tc('message.subscribers', 1) }}</b-dropdown-item-button>
            <!--                        <b-dropdown-item-button @click="toAddSubscriber" v-if="userIsMed"> {{ $tc('message.subscribers', 1) }}</b-dropdown-item-button>-->
          </b-dropdown>
          <b-button variant="danger" class="btn-sm mb-2 ml-2" v-if="can" v-b-modal.decede-modal>
            {{ decede =='non' ? $t('message.decede') : $t('message.nonDecede') }}
          </b-button>
        </div>

        <div class="card">
          <div class="" :class="[mobileView ? '': 'card-body']">
            <h3 class="card-title text-center mb-0">
              {{ fullName }}
            </h3>
            <p class="text-center">{{ smsEnvoye}} {{ $t('message.smsSended') }}</p>
          </div>
          <div class="container-fluid">
            <div class="list-group-flush">
              <div class="row">
              <div class="col-md-6 col-sm-6">
                <div>
                  <div class="list-group-item">
                    {{ $t('message.lastName') }}:
                    <span class="font-weight-bold">
                        {{ getValue(mPatientUserInformation.nom) }}
                    </span>
                  </div>
                </div>

                <div>
                  <div class="list-group-item">
                    {{ $t('message.firstName') }}:

                    <span class="font-weight-bold">
                        {{ mPatientUserInformation.prenom != null ? getValue(mPatientUserInformation.prenom) : " "}}
                    </span>
                  </div>
                </div>

                <div>
                  <div class="list-group-item">
                    {{ $t('message.dob') }}:

                    <span class="font-weight-bold">
                                {{ formattedDate(mPatient.date_de_naissance) }}
                            </span>
                  </div>
                </div>

                <div>
                  <div class="list-group-item">
                    {{ $t('message.email') }}:

                    <span class="font-weight-bold">
                                {{ getValue(mPatientUserInformation.email) }}
                            </span>
                  </div>
                </div>

                <div>
                  <div class="list-group-item">
                    {{ $t('message.phoneNumber') }}:

                    <span class="font-weight-bold">
                                {{ getValue(mPatientUserInformation.telephone) }}
                            </span>
                  </div>
                </div>
                
                <div>
                  <div class="list-group-item">
                    {{ $t('message.gender') }}:

                    <span class="font-weight-bold">
                                {{ mPatient.sexe }}
                            </span>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-6">
                <div>
                  <div class="list-group-item">
                    {{ $t('message.nationality') }}:
                    <span class="font-weight-bold">
                        {{ getValue(mPatientUserInformation.nationalite) }}
                    </span>
                  </div>
                </div>
                <div>
                  <div class="list-group-item">
                    {{ $tc('message.countries', 1) }}:

                    <span class="font-weight-bold">
                                {{ getValue(mPatientUserInformation.pays) }}
                            </span>
                  </div>
                </div>

                <div>
                  <div class="list-group-item">
                    {{ $tc('message.cities', 1) }}:

                    <span class="font-weight-bold">
                                {{ getValue(mPatientUserInformation.ville) }}
                            </span>
                  </div>
                </div>

                <div>
                  <div class="list-group-item">
                    {{ $t('message.street') }}:

                    <span class="font-weight-bold">
                                {{ getValue(mPatientUserInformation.quartier) }}
                            </span>
                  </div>
                </div>

                <div>
                  <div class="list-group-item">
                    {{ $t('message.zipCode') }}:

                    <span class="font-weight-bold">
                                {{ getValue(mPatientUserInformation.code_postal) }}
                            </span>
                  </div>
                </div>

                <div>
                  <div class="list-group-item">
                    {{ $t('message.address') }}:

                    <span class="font-weight-bold">
                                {{ getValue(mPatientUserInformation.adresse) }}
                            </span>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
          <div class="" :class="[mobileView ? 'ml-2': 'container']">
            <b-row class="justify-content-sm-center" v-if="can || hasAssistante">
              <div class="" :class="[mobileView ? 'card-title': 'card-footer text-right']">
                <b-button variant="primary" @click="updatePatient">
                  {{ $t('message.edit') }}
                </b-button>

                <b-button v-b-modal.delete-modal variant="danger">
                  {{ $t('message.delete') }}
                </b-button>
              </div>
            </b-row>
          </div>

          <b-container>
            <b-row>
              <b-col col sm="12">
                <hr>
                <h3 class="text-center">{{ $t('message.listOfPatientInstitution') }}</h3>
                <vue-good-table
                    id="allergie"
                    v-if="pInstitutions"
                    :columns="pInstitutionsColumns"
                    :rows="pInstitutions"
                    :search-options="enabled"
                    :pagination-options="paginationOptions"
                    :select-options="{
                                            enabled: true,
                                          }"
                    ref="institution-table"
                >
                  <div slot="selected-row-actions" v-if="hasGestionnaireRole || hasAdminRole || hasPraticienRole">
                    <button @click="removeEtablissement">Supprimer</button>
                  </div>
                </vue-good-table>
              </b-col>
            </b-row>
          </b-container>

          <b-modal
              id="delete-modal"
              size="sm"
              header-bg-variant="danger"
              header-text-variant="light"
              :title="$t('message.delete') + ' ' + $tc('message.patients', 1)"
              hide-footer
          >
            <div class="d-block text-center">
              <h3>{{ $t('message.delete') }} {{ mPatient.nom }}?</h3>
            </div>

            <div class="d-block float-right">
              <b-button variant="danger" @click="deletePatient">
                {{ $t('message.delete') }}
              </b-button>

              <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                {{ $t('message.cancel') }}
              </b-button>
            </div>
          </b-modal>
          <b-modal
              id="decede-modal"
              size="sm"
              header-bg-variant="danger"
              header-text-variant="light"
              :title="$t('message.cePatientEstDecede') "
              hide-footer
          >
            <div class="d-block text-center">
              <h3> {{ decede == 'non' ? $t('message.cePatientEstDecede') :$t('message.cePatientNEstDecede') }}</h3>
            </div>

            <div class="d-block float-right">
              <b-button variant="danger" @click="setAsDecede">
                {{ $t('message.yes') }}
              </b-button>

              <b-button variant="secondary" @click="$bvModal.hide('decede-modal')">
                {{ $t('message.no') }}
              </b-button>
            </div>
          </b-modal>
        </div>

        <div class="card">
          <div class="card-body">
            <b-container>
              <b-row>
                <b-col col sm="12">
                  <hr>
                  <h3 class="text-center">{{ $t('message.listOfSubscribers') }}</h3>
                  <vue-good-table
                      id="souscripteurs"
                      v-if="pSubscribers"
                      :columns="pSubscribersColumns"
                      :rows="pSubscribers"
                      :search-options="enabled"
                      :pagination-options="paginationOptions"
                      :select-options="{
                                            enabled: true,
                                          }"
                      ref="subscriber-table"
                  >
                    <div slot="selected-row-actions" v-if="hasGestionnaireRole || hasAdminRole || hasPraticienRole">
                      <button @click="removeSubscribers">Supprimer</button>
                    </div>
                  </vue-good-table>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import _ from 'lodash';
import i18n from "@/plugins/i18n";

export default {
  name: "Patient",

  computed: {
    ...mapGetters(["patient",'hasAdminRole',
      'hasGestionnaireRole','hasPraticienRole','hasMedecinControleRole','hasAssistante']),

    can:function(){
      return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante;
    },

    userIsMed:function(){
      return (JSON.parse(localStorage.getItem('user')))['isMedicasure'];
    },

    decede:function (){
      if (!_.isUndefined(this.mPatient.user)){
        return this.mPatient.user.decede;
      }else{
        return  'non';
      }
    },

    smsEnvoye:function (){
      if (!_.isUndefined(this.mPatient.user)){
        return this.mPatient.user.smsEnvoye;
      }else{
        return  '0';
      }
    },

    mPatient: function() {
      return this.patient;
    },

    mPatientUserInformation:function(){
      if (typeof this.mPatient.user == 'object'){
        return this.mPatient.user;
      }
      return [];
    },

    pInstitutions:function(){
      return this.mPatient.etablissements;
    },

    pSubscribers:function(){
      let fArray = [];
      if (!_.isNull(this.patient.souscripteur)){
        if (!_.isUndefined(this.patient.souscripteur)){
          if (!_.isUndefined(this.patient.souscripteur.user)){
            let user = this.patient.souscripteur.user;
            let prenom  = this.patient.souscripteur.user.prenom != null ? this.patient.souscripteur.user.prenom : "";
            prenom =  prenom.toLowerCase();
            let nom = (this.getValue(this.patient.souscripteur.user.nom)).toUpperCase()+ " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
            fArray.push({name:nom, email:user.email, update:false,slug:this.patient.souscripteur.slug})
          }
        }
      }

      if (!_.isUndefined(this.patient.financeurs)){
        let financeurs = this.patient.financeurs;
        let self = this;
        _.forEach(financeurs,function (financeur) {
          if (!_.isUndefined(financeur.financable)){
            if (!_.isUndefined(financeur.financable.user)){
              let user =financeur.financable.user;
              let prenom  = user.prenom != null ? user.prenom : "";
              prenom =  prenom.toLowerCase();
              let nom = (self.getValue(user.nom)).toUpperCase()+ " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
              fArray.push({name:nom, email:user.email,update:true,slug:financeur.slug})
            }
          }
        })
      }

      return fArray;
    },

    fullName:function () {
      let prenom  = this.mPatientUserInformation.prenom != null ? this.mPatientUserInformation.prenom : "";
      prenom =  prenom.toLowerCase();
      let nomComplet =  (this.getValue(this.mPatientUserInformation.nom)).toUpperCase()+ " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
      if (!_.isUndefined(this.patient.dossier)){
        nomComplet = nomComplet + " ( "+this.patient.dossier.numero_dossier+" ) ";
      }
      return nomComplet;
    }

  },

  data() {
    return {
      mobileView: true,
      patient_id: this.$route.params.patient,

      pSubscribersColumns:[
        {
          label: this.$i18n.t('message.name'),
          field: 'name',
        },

        {
          label: this.$i18n.t('message.email'),
          field: 'email',
        },
      ],

      pInstitutionsColumns:[
        {
          label: this.$i18n.t('message.name'),
          field: 'name',
        },
        {
          label: 'Description',
          field: 'description',
        },
      ],

      paginationOptions:{
        enabled: true,
        mode: 'records',
        perPageDropdown: [3, 6, 10]
      },

      enabled:{enabled: true},
    }
  },

  methods: {
    handleView() {
                this.mobileView = window.innerWidth <= 990;
            },
    getPatient() {
      let args = {
        patient: this.patient_id
      };

      this.$store.dispatch("getPatient", { args });
    },

    formattedDate(date) {
      return moment(date).format('DD-MM-YYYY');
    },

    toAddInstitution() {
      this.$router.push({ name: 'add-patient-institution', params: { patient: this.patient_id } })
    },

    toAddSubscriber(){
      this.$router.push({ name: 'add-patient-subscriber', params: { patient: this.patient_id } })
    },

    setAsDecede(){
      let self = this;
      let args = {
        patient: this.patient_id,
        decede:this.mPatient.user.decede == 'oui' ? 'non' :'oui'
      };

      let successMessage = this.$i18n.t('message.patientDecede');
      let errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.error')
      };

      this.$store.dispatch('decedePatient', { args, index: self.patient_id, successMessage, errorMessages }).then(() => {
        self.$bvModal.hide('decede-modal');
      });
    },

    updatePatient() {
      this.$router.push({ name: 'edit-patient', params: { patient: this.patient_id } });
    },

    deletePatient() {
      let self = this;
      let args = {
        patient: this.patient_id
      };

      let successMessage = this.$i18n.t('message.patientDeleted');
      let errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.error')
      };

      this.$store.dispatch('deletePatient', { args, index: self.patient_id, successMessage, errorMessages }).then(() => {
        self.$bvModal.hide('delete-modal');
        this.$router.back();

      });
    },
    getValue(item){
      if (typeof item != "undefined"){
        return item;
      }else{
        return "";
      }
    },

    removeEtablissement() {
      let etablissementId=[];
      _.forEach(this.$refs['institution-table'].selectedRows,function (row) {
        etablissementId.push(row.id)
      });

      let args = {
        patient_id: this.patient.user_id,
        etablissement_id:etablissementId
      };

      let successMessage = this.$i18n.t('message.institutionDeleted');
      let errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.error')
      };

      this.$store.dispatch('removePatientInstitution', { args, successMessage, errorMessages });
    },

    removeSubscribers(){
      let souscripteurs = [];
      let financable_slug = [];

      _.forEach(this.$refs['subscriber-table'].selectedRows,function (row) {
        if (row.update == true){
          financable_slug.push(row.slug);
        }else{
          souscripteurs.push(row.slug);
        }
      });
      let args = {
        patient_id: this.patient.user_id,
        financable_slug:financable_slug,
        souscripteurs:souscripteurs
      };

      let successMessage = this.$i18n.t('message.subscriberDeleted');
      let errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.error')
      };

      this.$store.dispatch('removePatientSubscriber', { args, successMessage, errorMessages });

    },
  },
  created() {
              this.handleView();
              window.addEventListener('resize', this.handleView);
          },
  mounted() {
    this.getPatient();
  }
}
</script>

<style scoped>

</style>